import styled from 'styled-components';

export const ThumbnailWrapper = styled.div<{ isTileView: boolean }>`
  margin-right: ${({ isTileView }) => !isTileView && '16px'};
`;
